import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _flatMap from "lodash/flatMap";
import _flatten from "lodash/flatten";
import _isArray from "lodash/isArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { unified } from 'unified';
import markdown from 'remark-parse';
import gfm from 'remark-gfm';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
var markdownNodeTypes = new Map([["paragraph", BLOCKS.PARAGRAPH], ["heading", "heading"], ["text", "text"], ["emphasis", "text"], ["strong", "text"], ["delete", "text"], ["inlineCode", "text"], ["link", INLINES.HYPERLINK], ["thematicBreak", BLOCKS.HR], ["blockquote", BLOCKS.QUOTE], ["list", "list"], ["listItem", BLOCKS.LIST_ITEM], ["table", BLOCKS.TABLE], ["tableRow", BLOCKS.TABLE_ROW], ["tableCell", BLOCKS.TABLE_CELL]]);

var nodeTypeFor = function nodeTypeFor(node) {
  var nodeType = markdownNodeTypes.get(node.type);

  if (isHeading(node)) {
    return "".concat(nodeType, "-").concat(node.depth);
  }

  if (isList(node)) {
    return "".concat(node.ordered ? "ordered" : "unordered", "-list");
  }

  return nodeType !== null && nodeType !== void 0 ? nodeType : node.type;
};

var isList = function isList(node) {
  return node.type === "list";
};

var isHeading = function isHeading(node) {
  return node.type === "heading";
};

var isLink = function isLink(node) {
  return node.type === "link";
};

var isTableCell = function isTableCell(node) {
  return node.type === "tableCell";
};

var isBlock = function isBlock(node) {
  return nodeContainerTypes.get(nodeTypeFor(node)) === "block";
};

var isText = function isText(node) {
  return nodeContainerTypes.get(nodeTypeFor(node)) === "text";
};

var isInline = function isInline(node) {
  return nodeContainerTypes.get(nodeTypeFor(node)) === "inline";
};

var markTypes = new Map([["emphasis", "italic"], ["strong", "bold"], ["inlineCode", "code"]]);

var markTypeFor = function markTypeFor(node) {
  return markTypes.get(node.type);
};

var nodeContainerTypes = new Map([["delete", "block"], [BLOCKS.HEADING_1, "block"], [BLOCKS.HEADING_2, "block"], [BLOCKS.HEADING_3, "block"], [BLOCKS.HEADING_4, "block"], [BLOCKS.HEADING_5, "block"], [BLOCKS.HEADING_6, "block"], [BLOCKS.LIST_ITEM, "block"], [BLOCKS.UL_LIST, "block"], [BLOCKS.OL_LIST, "block"], [BLOCKS.QUOTE, "block"], [BLOCKS.HR, "block"], [BLOCKS.PARAGRAPH, "block"], [BLOCKS.TABLE, "block"], [BLOCKS.TABLE_CELL, "block"], [BLOCKS.TABLE_HEADER_CELL, "block"], [BLOCKS.TABLE_ROW, "block"], [INLINES.HYPERLINK, "inline"], ["text", "text"], ["emphasis", "text"], ["strong", "text"], ["inlineCode", "text"]]);

var buildHyperlink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, fallback, appliedMarksTypes) {
    var content, hyperlink;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return mdToRichTextNodes(node.children, fallback, appliedMarksTypes);

          case 2:
            content = _context.sent;
            hyperlink = {
              nodeType: INLINES.HYPERLINK,
              data: {
                uri: node.url
              },
              content: content
            };
            return _context.abrupt("return", [hyperlink]);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function buildHyperlink(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var buildGenericBlockOrInline = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, fallback, appliedMarksTypes) {
    var nodeType, content;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            nodeType = nodeTypeFor(node);
            _context2.next = 3;
            return mdToRichTextNodes(node.children, fallback, appliedMarksTypes);

          case 3:
            content = _context2.sent;
            return _context2.abrupt("return", [{
              nodeType: nodeType,
              content: content,
              data: {}
            }]);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function buildGenericBlockOrInline(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var buildTableCell = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(node, fallback, appliedMarksTypes) {
    var nodeChildren, content;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return mdToRichTextNodes(node.children, fallback, appliedMarksTypes);

          case 2:
            nodeChildren = _context3.sent;
            content = nodeChildren.map(function (contentNode) {
              return {
                nodeType: BLOCKS.PARAGRAPH,
                data: {},
                content: [contentNode]
              };
            }); // A table cell can't be empty

            if (content.length === 0) {
              content.push({
                nodeType: BLOCKS.PARAGRAPH,
                data: {},
                content: [{
                  nodeType: "text",
                  data: {},
                  marks: [],
                  value: ""
                }]
              });
            }
            /**
             * We should only support texts inside table cells.
             * Some markdowns might contain html inside tables such as <ul>, <blockquote>, etc
             * but they are pretty much filtered out by markdownNodeTypes and nodeContainerTypes variables.
             * so we ended up receiving only `text` nodes.
             * We can't have table cells with text nodes directly, we must wrap text nodes inside paragraphs.
             */


            return _context3.abrupt("return", [{
              nodeType: BLOCKS.TABLE_CELL,
              content: content,
              data: {}
            }]);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function buildTableCell(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

var buildText = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(node, fallback, appliedMarksTypes) {
    var nodeType, markType, marks;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            nodeType = nodeTypeFor(node);
            markType = markTypeFor(node);
            marks = _toConsumableArray(appliedMarksTypes);

            if (markType) {
              marks.push(markType);
            }

            if (!(node.type !== "text" && node.type !== "inlineCode")) {
              _context4.next = 8;
              break;
            }

            _context4.next = 7;
            return mdToRichTextNodes(node.children, fallback, marks);

          case 7:
            return _context4.abrupt("return", _context4.sent);

          case 8:
            return _context4.abrupt("return", [{
              nodeType: nodeType,
              value: node.value,
              marks: marks.map(function (type) {
                return {
                  type: type
                };
              }),
              data: {}
            }]);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function buildText(_x10, _x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();

var buildFallbackNode = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(node, fallback) {
    var fallbackResult;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fallback(node);

          case 2:
            fallbackResult = _context5.sent;

            if (!_isArray(fallbackResult)) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", fallbackResult);

          case 5:
            return _context5.abrupt("return", [fallbackResult]);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function buildFallbackNode(_x13, _x14) {
    return _ref5.apply(this, arguments);
  };
}();

function mdToRichTextNode(_x15, _x16) {
  return _mdToRichTextNode.apply(this, arguments);
}

function _mdToRichTextNode() {
  _mdToRichTextNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(node, fallback) {
    var appliedMarksTypes,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            appliedMarksTypes = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : [];

            if (!isLink(node)) {
              _context7.next = 3;
              break;
            }

            return _context7.abrupt("return", buildHyperlink(node, fallback, appliedMarksTypes));

          case 3:
            if (!isTableCell(node)) {
              _context7.next = 5;
              break;
            }

            return _context7.abrupt("return", buildTableCell(node, fallback, appliedMarksTypes));

          case 5:
            if (!(isBlock(node) || isInline(node))) {
              _context7.next = 7;
              break;
            }

            return _context7.abrupt("return", buildGenericBlockOrInline(node, fallback, appliedMarksTypes));

          case 7:
            if (!isText(node)) {
              _context7.next = 9;
              break;
            }

            return _context7.abrupt("return", buildText(node, fallback, appliedMarksTypes));

          case 9:
            return _context7.abrupt("return", buildFallbackNode(node, fallback));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _mdToRichTextNode.apply(this, arguments);
}

function mdToRichTextNodes(_x17, _x18) {
  return _mdToRichTextNodes.apply(this, arguments);
}

function _mdToRichTextNodes() {
  _mdToRichTextNodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(nodes, fallback) {
    var appliedMarksTypes,
        rtNodes,
        _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            appliedMarksTypes = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : [];

            if (nodes) {
              _context8.next = 3;
              break;
            }

            return _context8.abrupt("return", Promise.resolve([]));

          case 3:
            _context8.next = 5;
            return Promise.all(nodes.map(function (node) {
              return mdToRichTextNode(node, fallback, appliedMarksTypes);
            }));

          case 5:
            rtNodes = _context8.sent;
            return _context8.abrupt("return", _flatten(rtNodes).filter(Boolean));

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _mdToRichTextNodes.apply(this, arguments);
}

var astToRichTextDocument = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(tree, fallback) {
    var content;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return mdToRichTextNodes(tree.children, fallback);

          case 2:
            content = _context6.sent;
            return _context6.abrupt("return", {
              nodeType: BLOCKS.DOCUMENT,
              data: {},
              content: content
            });

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function astToRichTextDocument(_x19, _x20) {
    return _ref6.apply(this, arguments);
  };
}();

function expandParagraphWithInlineImages(node) {
  if (node.type !== "paragraph") {
    return [node];
  }

  var imageNodeIndices = [];

  for (var i = 0; i < node.children.length; i++) {
    if (node.children[i].type === "image") {
      imageNodeIndices.push(i);
    }
  }

  if (imageNodeIndices.length === 0) {
    // If no images in children, return.
    return [node];
  }

  var allNodes = [];
  var lastIndex = -1;

  for (var j = 0; j < imageNodeIndices.length; j++) {
    var index = imageNodeIndices[j]; // Before

    if (index !== 0) {
      var nodesBefore = node.children.slice(lastIndex + 1, index);

      if (nodesBefore.length > 0) {
        allNodes.push(_objectSpread(_objectSpread({}, node), {}, {
          children: nodesBefore
        }));
      }
    } // Image


    var imageNode = node.children[index];
    allNodes.push(imageNode); // Till end

    var nodesAfter = [];
    var rangeEnd = j + 1 < imageNodeIndices.length ? imageNodeIndices[j + 1] : node.children.length;

    if (index + 1 < rangeEnd && index === imageNodeIndices.slice(-1)[0]) {
      nodesAfter = node.children.slice(index + 1, rangeEnd);

      if (nodesAfter.length > 0) {
        allNodes.push(_objectSpread(_objectSpread({}, node), {}, {
          children: nodesAfter
        }));
      }
    }

    lastIndex = index;
  }

  return allNodes;
}

var isParent = function isParent(node) {
  return "children" in node;
}; // Inline markdown images come in as nested within a MarkdownNode paragraph
// so we must hoist them out before transforming to rich text.


function prepareMdAST(ast) {
  function prepareASTNodeChildren(node) {
    if (!isParent(node)) {
      return node;
    }

    var children = _flatMap(node.children, function (n) {
      return expandParagraphWithInlineImages(n);
    }).map(function (n) {
      return prepareASTNodeChildren(n);
    });

    return _objectSpread(_objectSpread({}, node), {}, {
      children: children
    });
  }

  return prepareASTNodeChildren(ast);
} // COMPAT: can resolve with either Node or an array of Nodes for back compatibility.


function richTextFromMarkdown(_x21) {
  return _richTextFromMarkdown.apply(this, arguments);
}

function _richTextFromMarkdown() {
  _richTextFromMarkdown = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(md) {
    var fallback,
        processor,
        tree,
        ast,
        _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            fallback = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : function () {
              return Promise.resolve(null);
            };
            processor = unified().use(markdown).use(gfm);
            tree = processor.parse(md);
            ast = prepareMdAST(tree);
            return _context9.abrupt("return", astToRichTextDocument(ast, fallback));

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _richTextFromMarkdown.apply(this, arguments);
}

export default richTextFromMarkdown;